import { render, staticRenderFns } from "./IzinTanimla.vue?vue&type=template&id=091a8a86&scoped=true&"
import script from "./IzinTanimla.vue?vue&type=script&lang=js&"
export * from "./IzinTanimla.vue?vue&type=script&lang=js&"
import style0 from "./IzinTanimla.vue?vue&type=style&index=0&id=091a8a86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091a8a86",
  null
  
)

export default component.exports